<template>
  <div class="location">
        <label v-if="name">{{name | setText(title)}}</label><label v-else>{{title}}</label>
        <select v-model="val" @change="change">
          <option :value="null">{{'choose_language' | setText('Выберите язык')}}</option>
          <option v-for="(loc,key) in languages" :key="loc.id" v-bind:value="key">
            {{ loc }}
          </option>
        </select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Locale",
  props: {
    value: {
      default: null,
    },
    name: {
      default: null,
    },
    title: {
      default: 'Локализация содержимого',
    },
  },
  data() {
    return {
      val:null
    };
  },
  created() {
    this.val = this.value;
  },
  methods: {
    change(e) {
        this.$emit("input", this.val);
    },
  },
  computed: {
    ...mapState(["languages"]),
  },
};
</script>
<style lang="scss">
.location {
  select {
    padding: 5px 5px;
    width: 100%;
    height: 34px;
    border-radius: 10px;
    margin-bottom: 15px;
  }
}
</style>
